





























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { LoteNotificacaoProgresso } from '@/types/interfaces/LoteNotificacao'
import { loteFinalizado } from '@/composables/useLoteNotificacaoPolling/useLoteNotificacaoPolling'

@Component
export default class ModalNotificacaoEmailProcessamento extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean
  @Prop({ type: Object, default: () => null }) loteStatus!: LoteNotificacaoProgresso | null
  @Prop({ type: Number, default: 0 }) loteProgresso!: number

  get concluido() {
    return !!this.loteStatus && loteFinalizado(this.loteStatus.status)
  }

  get aparencia() {
    if (!this.concluido) return { titulo: 'Enviando e-mails...', icone: 'mdi-email-sync-outline', cor: 'primary' }
    if (this.loteStatus && this.loteStatus.status === 'Erro') return { titulo: 'Envio com erro', icone: 'mdi-alert-circle-outline', cor: 'error' }
    return { titulo: 'Processamento concluído', icone: 'mdi-check-circle-outline', cor: 'success' }
  }

  get textoAndamento() {
    if (this.loteStatus && this.loteStatus.status === 'Erro') return 'Nenhum e-mail foi enviado. Veja o motivo nos detalhes do lote.'
    if (this.concluido) return 'Todos os e-mails foram processados!'
    if (!this.loteStatus || !this.loteStatus.totalItens) return 'Preparando o envio...'
    return `${this.loteStatus.processados + this.loteStatus.erros} de ${this.loteStatus.totalItens} já processados`
  }

  @Emit('close')
  close() { }
}
